var React = require('react');

function Calendar (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#e74c3c","d":"M24 48h464v128H24z","key":0}),React.createElement("path",{"fill":"#e6e6e6","d":"M24 176h464v320H24z","key":1}),React.createElement("path",{"fill":"#b3b3b3","d":"M112 232h48v48h-48zM192 232h48v48h-48zM272 232h48v48h-48zM352 232h48v48h-48zM112 312h48v48h-48zM192 312h48v48h-48zM272 312h48v48h-48zM352 312h48v48h-48zM112 392h48v48h-48zM192 392h48v48h-48zM272 392h48v48h-48zM352 392h48v48h-48z","key":2}),React.createElement("rect",{"ry":"24","y":"16","x":"112","height":"112","width":"48","fill":"#7f8c8d","key":3}),React.createElement("rect",{"ry":"24","y":"16","x":"352","height":"112","width":"48","fill":"#7f8c8d","key":4})]);
}

Calendar.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = Calendar;

Calendar.default = Calendar;
